exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".reveals-popup .secondary-menu-header{position:absolute!important}.mobile-catalog{background:#003c3c}", ""]);

// exports
